import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalMessageService, RoutingService, TranslationService, WindowRef } from '@spartacus/core';
import { OrderConfirmationThankYouMessageComponent } from '@spartacus/order/components';
import { Order, OrderFacade } from '@spartacus/order/root';
import { ICON_TYPE } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter, map, skip,tap } from 'rxjs/operators';
import { GenBaseStoreService } from 'src/app/generac/services/base-store.service';
import { GenCustomerService } from 'src/app/generac/services/customer.service';
import { GenSavedCartFacade } from '../../../saved-cart/root/facade/saved-cart.facade';

@Component({
    selector: 'gen-order-confirmation-thank-you-message',
    templateUrl: './order-confirmation-thank-you-message.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenOrderConfirmationThankYouMessageComponent extends OrderConfirmationThankYouMessageComponent
  implements OnInit, AfterViewInit, OnDestroy {
  override order$: Observable<Order> = this.order$ as Observable<Order>;
  phoneNumber$ = this.baseStoreService.getPhoneNumber();
  subscription = new Subscription();
  isSplitWfOrderConfirmationPage: boolean;
  icon = ICON_TYPE.INFO;

  constructor(
    public override orderFacade: OrderFacade,
    public override globalMessageService: GlobalMessageService,
    public override translationService: TranslationService,
    protected winRef: WindowRef,
    protected savedCartService: GenSavedCartFacade,
    protected routingService: RoutingService,
    private customerService: GenCustomerService,
    private router: Router,
    private baseStoreService: GenBaseStoreService,
  ) {
    super(orderFacade, globalMessageService, translationService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.subscribeToUnitChange();
    this.isSplitWfOrderConfirmationPage = this.winRef.location.href.includes('order-confirmation?isSplitWfOrder=true');
  }

  override ngOnDestroy(): void {
    this.subscription.unsubscribe();
    super.ngOnDestroy();
  }

  // restore cart by subCartCode and redirect to checkout
  continueWithOrder(subCartCode: string, cartOwner: string): void {
    this.savedCartService.restoreSavedCart(subCartCode, cartOwner);
    this.subscription.add(
      this.savedCartService
        .getRestoreSavedCartProcessSuccess()
        .pipe(
          filter(success => success),
        ).subscribe(() => this.routingService.go({ cxRoute: 'checkout' }))
    );
  }
  private subscribeToUnitChange() {
    this.subscription.add(
      this.customerService.getB2bUnitChanged()
        .pipe(
          skip(1),
          filter(x => !!x)
        ).subscribe(x => this.router.navigate(['/']))
    )
  }

  hasPowerPlayApiSubscription(order: Order): boolean {
    return order.entries.some(entry => entry.product?.serviceProductType === 'API_SELLING');
  }

  hasFleetSubscription(order: Order): boolean {
    return order.entries.some(entry => entry.product?.serviceProductType === 'FLEET');
  }

}
